import { Farben } from "../shared/farben"

function chartSettings(data) {
	return data?.charteinstellungen || {}
}

function hiddenSeries(data) {
	const hs = chartSettings(data)?.hidden_series
	return Array.isArray(hs) ? hs.map(String) : []
}

function visibleBySettings(data, id, defaultVisible = true) {
	return hiddenSeries(data).includes(String(id)) ? false : defaultVisible
}

function isGewerblichGepraegt(data) {
	return chartSettings(data).steuerlich_gewerblich_gepraegt === "true"
}

export function seriesLiqui(data) {
	return [
		{
			name: "Depotwert",
			id: "bruttowerte",
			legendName: "Depotwert",
			yAxis: 0,
			type: "area",
			color: Farben.nettovermoegen,
			zIndex: 0,
			visible: visibleBySettings(data, "bruttowerte", data.status == "konsolidiert" ? true : false),
			showInLegend: data.status == "konsolidiert" ? true : false,
			data: data.bruttowerte,
		},
		{
			name: "Aktien",
			id: "aktien",
			legendName: "Aktien",
			yAxis: 0,
			type: "area",
			color: Farben.aktien,
			zIndex: 0,
			visible: visibleBySettings(data, "aktien", data.status == "konsolidiert" ? false : true),
			showInLegend: data.status == "konsolidiert" ? false : true,
			stack: "anlageklassen",
			data: data.aktien,
		},
		{
			name: "Anleihen",
			id: "anleihen",
			legendName: "Anleihen",
			yAxis: 0,
			type: "area",
			color: Farben.anleihen,
			zIndex: 0,
			visible: visibleBySettings(data, "anleihen", data.status == "konsolidiert" ? false : true),
			showInLegend: data.status == "konsolidiert" ? false : true,
			stack: "anlageklassen",
			data: data.anleihen,
		},
		{
			name: "Cash",
			id: "cash",
			legendName: "Cash",
			yAxis: 0,
			type: "area",
			color: Farben.cash,
			zIndex: 0,
			visible: visibleBySettings(data, "cash", data.status == "konsolidiert" ? false : true),
			showInLegend: data.status == "konsolidiert" ? false : true,
			stack: "anlageklassen",
			data: data.cashs,
		},
		{
			name: "Sonstiges",
			id: "sonstiges",
			legendName: "Sonstiges",
			yAxis: 0,
			type: "area",
			color: Farben.sonstiges,
			zIndex: 0,
			visible: visibleBySettings(data, "sonstiges", data.status == "konsolidiert" ? false : true),
			showInLegend: data.status == "konsolidiert" ? false : true,
			stack: "anlageklassen",
			data: data.sonstiges,
		},
		{
			name: "Einzahlungen",
			id: "einzahlungen",
			legendName: "Einzahlungen",
			yAxis: 1,
			type: "column",
			color: Farben.einnahmen,
			zIndex: 2,
			visible: visibleBySettings(data, "einzahlungen", true),
			stack: "ein_ausgaben",
			data: data.einzahlungen,
		},
		{
			name: "Auszahlungen",
			id: "auszahlungen",
			legendName: "Auszahlungen",
			yAxis: 1,
			type: "column",
			color: Farben.ausgaben,
			zIndex: 2,
			visible: visibleBySettings(data, "auszahlungen", true),
			stack: "ein_ausgaben",
			data: data.auszahlungen,
		},
		{
			name: "Anlage Überliquidität",
			id: "ueberliquiditaet",
			legendName: "Cash-Pooling",
			yAxis: 1,
			type: "column",
			color: Farben.liquidierung,
			zIndex: 2,
			visible: visibleBySettings(data, "ueberliquiditaet", true),
			stack: "ein_ausgaben",
			data: data.anlage_ueberliquiditaeten,
		},
		{
			name: "Automatische Liquidierung",
			id: "liquidierung",
			legendName: "Cash-Pooling",
			yAxis: 1,
			type: "column",
			color: Farben.liquidierung,
			zIndex: 2,
			visible: visibleBySettings(data, "liquidierung", true),
			stack: "ein_ausgaben",
			linkedTo: "ueberliquiditaet",
			data: data.automatische_liquidierungen,
		},
		{
			name: "Kosten",
			id: "kosten",
			legendName: "Kosten",
			yAxis: 1,
			type: "column",
			color: Farben.kosten,
			zIndex: 2,
			visible: visibleBySettings(data, "kosten", true),
			stack: "ein_ausgaben",
			data: data.kosten,
		},
	]
}

export function seriesSteuer(data) {
	const legendeKapitalertragPrivat = `Steuerpfl. Kapitalertrag ${isGewerblichGepraegt(data) ? "(Privat)" : ""}`
	const legendeSteuerbetragPrivat = `Kapitalertragsteuer ${isGewerblichGepraegt(data) ? "(Privat)" : ""}`

	return [
		{
			name: legendeKapitalertragPrivat,
			id: "kapitalertraege_privat",
			legendName: legendeKapitalertragPrivat,
			type: "column",
			color: Farben.zuVersteuerndesEinkommen,
			stacking: false,
			grouping: false,
			// pointPlacement: -0.15,
			zIndex: 0,
			visible: visibleBySettings(data, "kapitalertraege_privat", true),
			data: data.kapitalertraege_privat,
		},
		{
			name: legendeSteuerbetragPrivat,
			id: "steuerbetraege_privat",
			legendName: legendeSteuerbetragPrivat,
			type: "column",
			color: Farben.steuerBetrag,
			stacking: false,
			grouping: false,
			// pointPlacement: -0.15,
			zIndex: 1,
			visible: visibleBySettings(data, "steuerbetraege_privat", true),
			data: data.steuerbetraege_privat,
		},
		{
			name: "Steuerpfl. Ertrag (Unternehmen)",
			id: "kapitalertraege_unternehmen",
			legendName: "Steuerpfl. Ertrag (Unternehmen)",
			type: "column",
			color: Farben.kapitalertraegeUnternehmen,
			stacking: false,
			grouping: false,
			pointPlacement: 0.3,
			zIndex: 2,
			visible: visibleBySettings(data, "kapitalertraege_unternehmen", true),
			showInLegend: isGewerblichGepraegt(data),
			data: data.kapitalertraege_unternehmen,
		},
		{
			name: "Gewerbe- und Körperschaftsteuer",
			id: "steuerbetraege_unternehmen",
			legendName: "Gewerbe- und Körperschaftsteuer",
			type: "column",
			color: Farben.steuerbetraegeUnternehmen,
			stacking: false,
			grouping: false,
			pointPlacement: 0.3,
			zIndex: 3,
			visible: visibleBySettings(data, "steuerbetraege_unternehmen", true),
			showInLegend: isGewerblichGepraegt(data),
			data: data.steuerbetraege_unternehmen,
		},
	]
}
